module.exports = __webpack_public_path__ + "img/upcommingEvents2.2a7e8d30.jpg";